import type { parsePhotosForDocumentViewer, PhotoType } from "common/identity/document_viewer";

export type PhotoInfo = {
  src: string;
  type: PhotoType;
  side: "front" | "back";
  documentClaimedType: string | null;
  attempt: number;
  createdAt: string;
};

export function parsePhotoRecordToArray(
  photoRecord: ReturnType<typeof parsePhotosForDocumentViewer>,
  attempt: number,
  createdAt: string,
): PhotoInfo[] {
  return Object.entries(photoRecord).flatMap(([type, photo]) => {
    if (!photo) {
      return [];
    }

    return ["front", "back"]
      .map((side) => ({
        src: side === "front" ? photo.frontPicture : photo.backPicture,
        side: side as "front" | "back",
      }))
      .filter((photo): photo is { src: string; side: "front" | "back" } => photo.src !== null)
      .map(({ src, side }) => ({
        src,
        type: type as PhotoType,
        side,
        documentClaimedType: photo.documentClaimedType,
        attempt,
        createdAt,
      }));
  });
}
